"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgForward(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.49.15l.086.074 3.064 3.064a.766.766 0 01.074.998l-.074.085-3.064 3.064a.766.766 0 01-1.157-.997l.074-.086 1.74-1.741h-.751c-4.968 0-8.95 3.947-8.95 8.887a8.97 8.97 0 0017.941 0 .766.766 0 011.532 0c0 5.8-4.703 10.502-10.502 10.502C5.703 24 1 19.298 1 13.498 1 7.806 5.517 3.234 11.192 3.084l.29-.004.782-.001-1.77-1.771a.766.766 0 01-.075-.998l.074-.086a.766.766 0 01.998-.074z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgForward;
exports.default = _default;